// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-search';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.031 12.719a4.785 4.785 0 0 1 6.117-4.592M2.89 3.953a2.922 2.922 0 1 0 5.844 0 2.922 2.922 0 0 0-5.843 0zm5.048 7.703a3.719 3.719 0 1 0 7.437 0 3.719 3.719 0 0 0-7.438 0zm9.031 5.313-2.683-2.683'
  />
);

export const viewBox = '0 0 18 18';
